import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/marmalade';
import React from 'react';
import styles from './AISearch.module.scss';

interface AISearchProps {
    isEnabled: boolean;
    onClick: () => void;
}

export const AISearchCTA = ({ isEnabled, onClick }: AISearchProps) => {
    if (!isEnabled) {
        return null;
    }

    return (
        <div className={styles.root}>
            <Button onClick={onClick} variant="primary">
                {gettext('Try the concierge ✨')}
            </Button>
        </div>
    );
};
